import { brsApi } from 'api';
import { FeatureEligibility } from 'pco-product-service-internal-consumer';

export const getIsBrEligible = async (brUid: string): Promise<FeatureEligibility[]> => {
  const response = await brsApi.isBrEligible({ brUid });
  return response.features ?? [];
};
